import React, { Fragment, useRef, useState } from "react";
import { Alerts } from "./Alert";
import { userContext } from "./FormComponent";
import { useContext } from "react";
import { Select } from "./Select";
import { DataList } from "./DataList";
import { getFunction } from "../../../utils/getFunction";
import { Question } from "../../../core/Model/Question";
import { extraerNumeros } from "../../../utils/extraerNumeros";
import { getMessage } from "../../../utils/getMessage";
import { getImage } from "../../../utils/getImage";
import { ImageResponses } from "./ImageResponses";
import { CharCounter } from "./CharCounter";
import { DataListComponent } from "../../DataListComponent";
import { SelectSearch } from "./SelectSearch";

export default function Inputs(props) {
  const {
    response,
    PreguntaId,
    accumulativeIdQuestions,
    idQuestion,
    questions,
    setSingleIdQuestion,
    encuestaNueva,
  } = props;

  const { showTextCounter, showstars, maxChars } = useContext(userContext);

  const [showComponent, setShowComponent] = useState(false);
  const [rendered, setRendered] = useState(false);
  const [rigor, setRigor] = useState(null);
  const [msj, setMsj] = useState(null);
  const [contadorTexto, setContadorTexto] = useState(0);
  const [lastAdded, setLastAdded] = useState([]);
  const [lastQuestionId, setLastQuestionId] = useState(null);
  //const { showstars } = useContext(userContext);

  const survey = process.env.REACT_APP_NAME_FORM;

  //Toma el id de la esrtrella elegida para usarlo para mostrar el texto de la respuesta en el alert
  const defineMessage = (e) => {
    if (showstars) {
      let id = parseInt(extraerNumeros(e.target.htmlFor));
      let resp = response.find((res) => res.RespuestaId == id);
      setMsj(resp.RespuestaTexto);
      if (
        resp.RespuestaTexto == "Muy Satisfecho" ||
        resp.RespuestaTexto == "Satisfecho" ||
        resp.RespuestaTexto == "Muy satisfactoria" ||
        resp.RespuestaTexto == "Satisfactoria" ||
        resp.RespuestaTexto == "Muy fácil" ||
        resp.RespuestaTexto == "Fácil" ||
        resp.RespuestaTexto == "Si" ||
        resp.RespuestaTexto == "Sí"
      ) {
        setRigor("success");
      } else if (
        resp.RespuestaTexto == "Neutro" ||
        resp.RespuestaTexto == "Neutral" ||
        resp.RespuestaTexto == "Ni satisfecho ni insatisfecho" ||
        resp.RespuestaTexto == "Como lo esperaba"
      ) {
        setRigor("info");
      } else if (
        resp.RespuestaTexto == "Insatisfecho" ||
        resp.RespuestaTexto == "Poco satisfactoria" ||
        resp.RespuestaTexto == "Difícil"
      ) {
        setRigor("warning");
      } else {
        setRigor("error");
      }
      setShowComponent(true);
    }

    handleHiddenQuestionRadio(e);
  };

  //Muestra o esconde las preguntas hijas al hacer clic en los input radio
  const handleHiddenQuestionRadio = (e) => {
    const resId = e.target.id;
    const res = response.find((r) => r.RespuestaId == resId);
    const idSubpregunta = JSON.parse(res.SubPreguntaId);
    // console.log(
    //   "PreguntaId:",
    //   PreguntaId,
    //   "lastQuestionId:",
    //   lastQuestionId,
    //   "idSubpregunta:",
    //   idSubpregunta,
    //   "lastAdded:",
    //   lastAdded
    // );
    // 👉 Caso 1: es un arreglo de IDs
    if (Array.isArray(idSubpregunta)) {
      console.log("Es un array, agrega varios id");
      idQuestion((prev) => [...prev, ...idSubpregunta]);
      setLastAdded(idSubpregunta);
      setLastQuestionId(PreguntaId);
    }
    // 👉 Caso 2: es un número válido
    if (typeof idSubpregunta === "number" && !isNaN(idSubpregunta)) {
      // 👉 Caso 3: Si es 0, se desprenden 2 casos: si es la misma pregunta que el último clic, eliminar el último id agregado, si es otra pregunta, no hacer nada
      if (idSubpregunta === 0) {
        if (PreguntaId === lastQuestionId) {
          console.log(`Es cero y misma pregunta ${PreguntaId} - ${lastQuestionId}, quitando último agregado`, lastAdded);
          // eliminar últimos agregados (grupo anterior)
          idQuestion((prev) => prev.filter((id) => !lastAdded.includes(id)));
          setLastAdded([]);
        } else {
          console.log(`Es cero y distinta pregunta ${PreguntaId} - ${lastQuestionId}, no hace nada`);
          // no hacer nada, solo se deja registro que no hay últimos agregados
          setLastAdded([]);
        }
      } else {
        // 👉 Caso 4: Si es distinto de 0, se agrega la subpregunta. Si es la misma pregunta que el último clic, se elimina el último id agregado antes de agregar el nuevo
        if (PreguntaId === lastQuestionId) {
          console.log(`Distinto de cero y misma pregunta ${PreguntaId} - ${lastQuestionId}, reemplazando último agregado`, lastAdded, idSubpregunta);
          idQuestion((prev) => {
            const newArr = [...prev, idSubpregunta];
            // eliminar el último elemento agregado antes de este, solo si se agregó algo, porque si el último clic fue en un id 0, no hay que eliminar nada
            if (prev.length > 0 && lastAdded.length > 0) newArr.splice(prev.length - 1, 1);
            return newArr;
          });
          setLastAdded([idSubpregunta]);
        } else {
          console.log(`Distinto de cero y distinta pregunta ${PreguntaId} - ${lastQuestionId}, agregando nuevo id`, idSubpregunta);
          idQuestion((prev) => [...prev, idSubpregunta]);
          setLastAdded([idSubpregunta]);
        }
        setLastQuestionId(PreguntaId);
      }
    }
    enableSendButton(e);
  };

  const handleHiddenQuestionCheckbox = (e) => {
    let checkboxNodes = e.target.parentElement.parentElement.children;
    let checkboxArray = [...checkboxNodes];

    const resId = e.target.id;
    let checked = e.target.checked;
    if (checked && e.target.parentElement.textContent.includes("Otro")) {
      const res = response.find((r) => r.RespuestaId == resId);
      const idSubpregunta = res.SubPreguntaId;
      idQuestion([...accumulativeIdQuestions, parseInt(idSubpregunta)]);

      //Quita los checks de los inputs que han sido seleccionalos cuando se selecciona la opción "Otros"
      for (const i of checkboxArray) {
        if (i.textContent.includes("Otro")) continue;
        if (i.children[0].checked) i.children[0].checked = false;
      }
    } else if (
      !checked &&
      e.target.parentElement.textContent.includes("Otro")
    ) {
      //Esconde la pregunta hija
      const res = response.find((r) => r.SubPreguntaId != 0);
      const idHermana = res.SubPreguntaId;
      let temp = [...accumulativeIdQuestions];
      const indice = temp.indexOf(idHermana);
      const hija = temp[indice];

      //quita la pregunta hija de la pantalla
      temp = temp.filter((item) => item != temp[indice]);

      //quita la pregunta hija de la hija de la pantalla porque son dependientes. Si la madre no se muestra, la hija tampoco
      const nieta = questions.filter((q) => q.PreguntaIdPadre == hija);
      if (nieta.length > 0) {
        temp = temp.filter((item) => item != nieta[0].PreguntaId);
      }
      idQuestion(temp);
    } else if (
      checked &&
      !e.target.parentElement.textContent.includes("Otro")
    ) {
      //Quita el check de la opcion "Otros" porque se ha seleccionado otras de las opciones. También esconde la pregunta hija
      checkboxArray[checkboxArray.length - 1].children[0].checked = false;
      const res = response.find((r) => r.SubPreguntaId != 0);
      const idHermana = res.SubPreguntaId;
      let temp = [...accumulativeIdQuestions];
      const indice = temp.indexOf(idHermana);
      const hija = temp[indice];

      //quita la pregunta hija de la pantalla
      temp = temp.filter((item) => item != temp[indice]);

      //quita la pregunta hija de la hija de la pantalla porque son dependientes. Si la madre no se muestra, la hija tampoco
      const nieta = questions.filter((q) => q.PreguntaIdPadre == hija);
      if (nieta.length > 0) {
        temp = temp.filter((item) => item != nieta[0].PreguntaId);
      }
      idQuestion(temp);
    }
  };

  const handleChange = (selectedOption) => {
    const idSelection = selectedOption.value;
    const res = response.find((r) => r.RespuestaId == idSelection);
    const idSubpregunta = res?.SubPreguntaId;
    //console.log(idSubpregunta)
    idQuestion([...accumulativeIdQuestions, parseInt(idSubpregunta)]);
    if (idSubpregunta == 0 && accumulativeIdQuestions.length >= 1) {
      const res = response.find((r) => r.SubPreguntaId != 0);
      if (res) {
        const idHermana = res.SubPreguntaId;
        let temp = [...accumulativeIdQuestions];
        const indice = temp.indexOf(idHermana);
        const hija = temp[indice];
        temp = temp.filter((item) => item != temp[indice]);
        // const nieta = questions.filter((q) => q.PreguntaIdPadre == hija);

        // if (nieta.length > 0) {
        //   temp = temp.filter((item) => item != nieta[0].PreguntaId);
        // }
        idQuestion(temp);
      }
    }
  };

  const handleHiddenQuestionSelect = (e) => {
    const index = e.target.selectedIndex;
    const selectedOption = e.target.options[index];
    const idSelection = selectedOption.id;
    const res = response.find((r) => r.RespuestaId == idSelection);
    const idSubpregunta = JSON.parse(res?.SubPreguntaId);
    if (Array.isArray(idSubpregunta)) {
      idQuestion((prev) => [...prev, ...idSubpregunta]);
      setLastAdded(idSubpregunta);
    } else if (idSubpregunta === 0) {
      idQuestion((prev) => prev.filter((id) => !lastAdded.includes(id)));
      setLastAdded([]); // limpiar registro
    }

    enableSendButton(e);
  };

  //Habilita el botón enviar si es que se usa esa validación para las preguntas obligatorias
  const enableSendButton = (e) => {
    let value = e.target.value;
    //console.log(e.target.type)
    if (value && e.target.tagName !== "TEXTAREA") {
      document.querySelector(".btnSend.disabled")?.classList.toggle("disabled");
    }
  };

  /*
  const limitCharacters = (e) => {
    let text = e.target.value;
    const maxLength = maxChars;
    setContadorTexto(text.length);
    if (text.length >= maxLength) {
      e.target.value = text.substring(0, maxLength);
    }
    enableSendButton(e);
  };
  */

  const limitCharacters = (e, maxFromProp) => {
    const fallbackMax = 100;
    const maxLength = maxFromProp ?? maxChars ?? fallbackMax;

    let text = e.target.value;
    setContadorTexto(text.length);

    if (text.length >= maxLength) {
      e.target.value = text.substring(0, maxLength);
    }

    enableSendButton(e);
  };

  const shouldHideContainer = response.some(
    (e) => e.RespuestaTexto === "" && e.RespuestaTipo === "radio"
  );

  const isVertical = response.some((e) => e.RespuestaTipo === "radio-vertical");

  return (
    <div
      className={`containerRespuesta ${
        shouldHideContainer ? "hide-it override-visibility" : ""
      } ${isVertical ? "radio-vertical" : ""}`}
    >
      {showstars && showComponent && <Alerts message={msj} rigor={rigor} />}
      {response.map((e, index) => {
        if (e.RespuestaTipo === "radio") {
          const totalRadios = response.length;
          return (
            <label
              key={e.RespuestaId}
              id={e.RespuestaId}
              className={`radio-option radio-group`}
            >
              <input
                //cambié getFunction por handleHiddenQuestionRadio
                onClick={handleHiddenQuestionRadio}
                className={
                  e.RespuestaQuality === "bad"
                    ? "bad"
                    : e.RespuestaQuality === "regular"
                    ? "regular"
                    : e.RespuestaQuality === "good"
                    ? "good"
                    : e.RespuestaTexto === "Bueno"
                    ? "bueno"
                    : "malo"
                }
                type={"radio"}
                name={PreguntaId}
                value={e.RespuestaId}
                id={e.RespuestaId}
                subpreguntaid={e.SubPreguntaId}
              />
              <i></i>
              <span
                className={`labelRes ${
                  e.RespuestaQuality ? e.RespuestaQuality : ""
                }`}
              >
                <a>{e.RespuestaTexto}</a>
              </span>
            </label>
          );
        } else if (e.RespuestaTipo === "radio-vertical") {
          const totalRadios = response.length;
          return (
            <label
              key={e.RespuestaId}
              id={e.RespuestaId}
              className={`radio-option radio-vertical-item`}
            >
              <input
                //cambié getFunction por handleHiddenQuestionRadio
                onClick={handleHiddenQuestionRadio}
                className={
                  e.RespuestaQuality === "bad"
                    ? "bad"
                    : e.RespuestaQuality === "regular"
                    ? "regular"
                    : e.RespuestaQuality === "good"
                    ? "good"
                    : e.RespuestaTexto === "Bueno"
                    ? "bueno"
                    : "malo"
                }
                type={"radio"}
                name={PreguntaId}
                value={e.RespuestaId}
                id={e.RespuestaId}
                subpreguntaid={e.SubPreguntaId}
              />
              <i></i>
              <span
                className={`labelRes ${
                  e.RespuestaQuality ? e.RespuestaQuality : ""
                }`}
              >
                <a>{e.RespuestaTexto}</a>
              </span>
            </label>
          );
        } else if (e.RespuestaTipo === "star")
          return (
            <Fragment key={e.RespuestaId}>
              <input
                onClick={enableSendButton}
                id={`star${e.RespuestaId}`}
                className="inputs"
                type={"radio"}
                name={PreguntaId}
                subpreguntaid={e.SubPreguntaId}
              />
              <label
                onClick={defineMessage}
                htmlFor={`star${e.RespuestaId}`}
                id={e.RespuestaId}
                className="star"
              >
                &#9733;
              </label>
            </Fragment>
          );
        else if (e.RespuestaTipo === "image") {
          //console.log(response[index].RespuestaQuality);
          if (
            response[index].RespuestaQuality !==
            response[index + 1]?.RespuestaQuality
          ) {
            return (
              <Fragment key={e.RespuestaId}>
                <ImageResponses
                  enableSendButton={enableSendButton}
                  key={e.RespuestaId}
                  quality={e.RespuestaQuality}
                  responses={response}
                  PreguntaId={PreguntaId}
                  encuestaNueva={encuestaNueva}
                />
              </Fragment>
            );
          }
          return null;
        } else if (e.RespuestaTipo === "select") {
          return (
            <Fragment key={e.RespuestaId}>
              {response.length == index + 1 ? (
                <Select
                  key={e.RespuestaId}
                  idPregunta={PreguntaId}
                  array={response}
                  handleHiddenQ={handleHiddenQuestionSelect}
                  subpreguntaid={e.SubPreguntaId}
                />
              ) : (
                ""
              )}
            </Fragment>
          );
        } else if (e.RespuestaTipo === "Autocomplete") {
          return (
            <Fragment key={e.RespuestaId}>
              {response.length == index + 1 ? (
                <>
                  <SelectSearch
                    key={e.RespuestaId}
                    idPregunta={PreguntaId}
                    array={response}
                    subpreguntaid={e.SubPreguntaId}
                  />
                </>
              ) : (
                ""
              )}
            </Fragment>
          );
        } else if (e.RespuestaTipo === "datalist") {
          return (
            <Fragment key={e.RespuestaId}>
              {response.length == index + 1 ? (
                <DataListComponent
                  // key={e.RespuestaId}
                  // idPregunta={PreguntaId}
                  dataOptions={response}
                  // handleHiddenQ={handleHiddenQuestionSelect}
                  // subpreguntaid={e.SubPreguntaId}
                />
              ) : (
                ""
              )}
            </Fragment>
          );
        } else if (e.RespuestaTipo === "Input") {
          return (
            <Fragment key={e.RespuestaId}>
              <input
                type="text"
                name={PreguntaId}
                subpreguntaid={e.SubPreguntaId}
                placeholder={
                  PreguntaId == 241
                    ? "Nombre Completo"
                    : PreguntaId == 242
                    ? "DNI"
                    : "Celular"
                }
              />
            </Fragment>
          );
        } else if (e.RespuestaTipo === "email") {
          return (
            <Fragment key={e.RespuestaId}>
              <input
                type="email"
                name={PreguntaId}
                subpreguntaid={e.SubPreguntaId}
                placeholder={getMessage(32)}
              />
            </Fragment>
          );
        } else if (e.RespuestaTipo === "checkbox") {
          return (
            <Fragment key={e.RespuestaId}>
              <label>
                <input
                  onClick={handleHiddenQuestionCheckbox}
                  id={e.RespuestaId}
                  className="checkbox"
                  type="checkbox"
                  name={PreguntaId}
                  subpreguntaid={e.SubPreguntaId}
                />
                {e.RespuestaTexto}
              </label>
            </Fragment>
          );
        } else if (e.RespuestaTipo === "text") {
          const maxLength = e.PreguntasMaxCaracteres;

          return (
            <div
              className="containerText"
              key={e.RespuestaId}
              id={e.RespuestaId}
            >
              <textarea
                onChange={(ev) => limitCharacters(ev, maxLength)}
                className={`textarea ${
                  maxLength <= 6
                    ? "textarea-6-chars"
                    : maxLength <= 50
                    ? "textarea-50-chars"
                    : ""
                }`}
                placeholder={getMessage(11)}
                name={PreguntaId}
                subpreguntaid={e.SubPreguntaId}
              ></textarea>
              {showTextCounter && (
                <CharCounter
                  contadorTexto={contadorTexto}
                  maxFromProp={maxLength}
                />
              )}
            </div>
          );
        }
      })}
    </div>
  );
}
